function aresLookup(formId) {
    var data,
        url = '/scripts/getares.php',
        ic = document.getElementById('ic'),
        dic = document.getElementById('dic'),
        street = document.getElementById('street'),
        city = document.getElementById('city'),
        postcode = document.getElementById('postcode'),
        company = document.getElementById('company'),

        icVal = ic.value.trim(),

        form_id = formId,
        field = ic,
        field_name = field.name,
        field_id = field.id,
        field_error = document.querySelector('#' + field_id + ' ~ .field-error'),

        aresMessage = document.getElementById('ares-success-message');

    const httpRequest = new XMLHttpRequest();

    if (icVal.length == 8 && icVal.search(/^[0-9]+$/) != -1 && checkIc(icVal)) {
        if (!httpRequest) {
            // console.log('Giving up :( Cannot create an XMLHTTP instance');
            return false;
        }
        httpRequest.onreadystatechange = function() {
            try {
                if (httpRequest.readyState === XMLHttpRequest.DONE) {
                    if (httpRequest.status === 200) {
                        data = JSON.parse(httpRequest.responseText);
                        // console.log(data);
                        // if (data.dic) dic.value = data.dic;
                        dic.value = data.dic ?? '';
                        if (data.street) street.value = data.street;
                        if (data.city) city.value = data.city;
                        if (data.postcode) postcode.value = data.postcode;
                        if (data.company) company.value = data.company;
                        if (data.result == 2 || data.result == 3) {
                            var error_type;
                            switch (data.result) {
                                case 2:
                                    error_type = 'icNotFound';
                                    break;
                                case 3:
                                    error_type = 'aresUnavailable';
                                    break;
                            }
                            showError(field, field_error, error_type, form_id, field_name);
                            field.addEventListener('input', function() {
                                field_error.textContent = '';
                                field_error.className = 'field-error';
                            }, {
                                once: true
                            });
                        } else {
                            if (aresMessage) {
                                const text = aresMessage.getAttribute('data-text');
                                aresMessage.textContent = text;
                                // console.info(text);
                            }
                        }
                        checkForm(form_id, 1);
                    } else {
                        // console.log('There was a problem with the request.');
                    }
                }
            } catch (e) {
                // console.log('Caught Exception: ' + e.description);
            }
        };
        httpRequest.open('POST', url);
        httpRequest.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        httpRequest.send('ic=' + icVal);
    } else {
        showError(field, field_error, 'invalidIc', form_id, field_name);
        field.addEventListener('input', function() {
            field_error.textContent = '';
            field_error.className = 'field-error';
        }, {
            once: true
        });
    }
}